var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{staticClass:"mb-10",attrs:{"timeout":_vm.timeout,"min-width":"0"},model:{value:(_vm.innerShow),callback:function ($$v) {_vm.innerShow=$$v},expression:"innerShow"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }